import React from "react";
import CodeExecutor from "../../../../../components/CodeExecutor/CodeExecutor.js";
import {
    Card,
    Container,
    Row,
    Col,
    CardHeader,
    CardBody,
    CardTitle,
    CardText,
    Button,
    CardFooter,
} from "reactstrap";
import DemoNavbar from "components/Navbars/DemoNavbar.js";

class PrimitativeDataTypes extends React.Component {



    constructor(props) {
        super(props);
        this.state = {
            initialCode: `public class Main
{
    public static void main(String[] args) {
        System.out.println("Welcome to Online IDE!! Happy Coding :)");
    }
}`,
        };
    }


    componentDidMount() {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        this.refs.main.scrollTop = 0;
    }


    render() {
        const { initialCode } = this.state;
        return (
            <>
                <DemoNavbar />

                <main ref="main">
                    <section className="section section-shaped section-lg">
                        <div className="  shape shape-style-1 bg-gradient-default">
                            <span />
                            <span />
                            <span />
                            <span />
                            <span />
                            <span />
                            <span />
                            <span />
                        </div>

                        <Row className="justify-content-center ">

                            <Col style={{ padding: 0 }}>
                                <CodeExecutor languageCode="java" initialCode={initialCode} >
                                    <Card
                                        className="my-2 lessonCard "
                                        style={{
                                            width: "18rem",
                                        }}
                                    >
                                        <CardHeader>Introduction to Primitive Data Types</CardHeader>
                                        <CardBody>
                                            <CardTitle tag="h5">What are Primitive Data Types?</CardTitle>
                                            <CardText>
                                                Primitive data types are the most basic data types available in Java. They are predefined by the language and named by a keyword.
                                            </CardText>
                                            <CardTitle tag="h5">Importance of Data Types</CardTitle>
                                            <CardText>
                                                Data types specify the different sizes and values that can be stored in the variable.                                            </CardText>
                                        </CardBody>
                                        <CardBody>
                                            <CardTitle tag="h5">What are Primitive Data Types?</CardTitle>
                                            <CardText>
                                                Primitive data types are the most basic data types available in Java. They are predefined by the language and named by a keyword.
                                            </CardText>
                                            <CardTitle tag="h5">Importance of Data Types</CardTitle>
                                            <CardText>
                                                Data types specify the different sizes and values that can be stored in the variable.                                            </CardText>
                                        </CardBody>
                                        <CardFooter>Footer</CardFooter>
                                    </Card>
                                </CodeExecutor>
                            </Col>

                        </Row>

                    </section>

                </main>
            </>
        );
    }
}

export default PrimitativeDataTypes;
